<template>
	<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		<div class="mb-2 mt-2 pt-3">
				<template>
					<el-form inline ref="form" :model="from" label-width="100px">
						<el-form-item :label="$t('supplierList.name')" class="mb-0">
							<el-input size="small" v-model="from.name" ></el-input>
						</el-form-item>
						
						<el-form-item :label="$t('layout.createTime')"  class="mb-0">
							 <el-date-picker
							      size="small"
							      v-model="from.time"
							      type="daterange"
							      align="right"
							      unlink-panels
								  value-format="yyyy-MM-dd"
							      :range-separator="$t('system.to')"
							      :start-placeholder="$t('system.startTime')"
							      :end-placeholder="$t('system.endTime')"
							      >
							    </el-date-picker>
						</el-form-item>
						
						<el-form-item class="mb-0">
							<el-button type="info" @click="searchEvent" size="small">{{$t('system.search')}}</el-button>
							<el-button size="small" @click="clearSearch">{{$t('system.reset')}}</el-button>
						</el-form-item>
				
					</el-form>
					<div style="margin-top:10px">
						<el-button size="small" @click="openModel(false)" v-auth="'add'+auth_val" >{{$t('supplierList.add')}}</el-button>
					</div>
			</template>
		</div>

		<!-- 表格 -->
		<div class="mt-3 pt-2" style="padding-bottom:20px">
			<el-table :data="tableData" style="width: 100%" @selection-change="handleSelectionChange">
				
				<el-table-column align="center"  prop="sort" :label="$t('supplierList.sort')">
				</el-table-column>

				<el-table-column align="center"  prop="id" label="ID">
				</el-table-column>
				<el-table-column align="center"  prop="name" :label="$t('supplierList.name')">
				</el-table-column>
				<el-table-column align="center"  prop="username" :label="$t('supplierList.loginName')">
				</el-table-column>
       
				<el-table-column align="center" prop="status" width="90" :label="$t('adminList.loginStatus')">
					<template slot-scope="scope">
						<el-button
							:type="scope.row.status ? 'success' : 'danger'" 
							size="mini"
							@click="changeStatus(scope.row,'status')"
							plain>{{scope.row.status ? $t('adminList.normalLogin') : $t('adminList.forbidLogin')}}
						</el-button>
					</template>
				</el-table-column>

				<el-table-column align="center" prop="phone" :label="$t('supplierList.phone')">
				</el-table-column>
                <el-table-column align="center" prop="email" :label="$t('supplierList.email')">
				</el-table-column>
                <el-table-column align="center" prop="local" :label="$t('supplierList.local')">
				</el-table-column>

				<el-table-column align="center" prop="create_time" :label="$t('layout.createTime')">
				</el-table-column>
				<el-table-column prop="id" align="center" width="160" :label="$t('layout.operation')">
					<template slot-scope="scope">
						<el-button-group>
							<el-button size="mini" plain type="primary" v-auth="'edit'+auth_val" @click="openModel(scope)">{{$t('layout.operation')}}</el-button>
							<el-button @click="deleteItem(scope.row)" v-auth="'del'+auth_val" size="mini" plain type="danger">{{$t('layout.delete')}}</el-button>
						</el-button-group>
					</template>
				</el-table-column>
			</el-table>
		</div>



		<el-footer
		class="d-flex border-top bg-white align-items-center px-0 position-fixed"
		:style="{ bottom: '0', left: computedLeft, right: '0', zIndex: '100' }"
		>
			<div style="flex: 1;" class="px-2">
				<el-pagination
				:current-page="page.current"
				:page-sizes="page.sizes"
				:page-size="page.size"
				@size-change="handleSizeChange"
				@current-change="handleCurrentChange"
				background
                :layout="layout.isMobile ? 'total, prev, pager, next' : 'total, prev, pager, next, sizes, jumper'"
				:total="page.total"
				/>
			</div>
		</el-footer>

		<el-dialog :close-on-click-modal="false"
			:title="editIndex > -1 ? $t('supplierList.edit') : $t('supplierList.add')"
			:visible.sync="createModel"
			top="5vh"
			:width="layout.is_phone?'90%':'80%'"
			:append-to-body="true"
			@close="hide"
			custom-class="custom-dialog">
			<!-- 表单内容 -->
			<el-form style="max-height: 65vh; overflow: auto;" :rules="rules" ref="form" :model="form" :label-width="layout.is_phone?'80px':'100px'">
				<el-form-item :label="$t('supplierList.avatar')" prop="icon">
					<el-upload
						name="file"
						class="avatar-uploader"
						action="/admin/image/uploadNew"
						:headers="{token:$store.state.user.token}"
						:data="{type:'2'}"
						:show-file-list="false"
						:on-success="handleAvatarSuccess"
						:before-upload="beforeAvatarUpload">
						<img v-if="form.icon" :src="form.icon" class="avatar">
						<i v-else class="el-icon-plus avatar-uploader-icon"></i>
					</el-upload>
				</el-form-item>
				
				
				<el-form-item :label="$t('supplierList.sort')" prop="sort">
					<el-input v-model="form.sort"  clearable size="small" :placeholder="$t('supplierList.sort')"  style="width: 85%;"></el-input>
				</el-form-item>
				<el-form-item :label="$t('supplierList.loginName')" prop="username">
					<el-input  v-model="form.username" :maxlength="16" :minlength="6" :placeholder="$t('supplierList.loginName')" clearable size="small" style="width: 85%;" auto-complete="new-password"></el-input>
				</el-form-item>
				<el-form-item :label="$t('supplierList.name')" prop="name">
					<el-input v-model="form.name"  clearable size="small" :placeholder="$t('supplierList.name')"  style="width: 85%;"></el-input>
				</el-form-item>
				<el-form-item prop="password" :label="$t('supplierList.loginPassword')">
					<el-input v-model="form.password" :maxlength="16" :minlength="6" show-password :placeholder="$t('supplierList.loginPassword')" size="small" auto-complete="new-password" style="width: 85%;"></el-input>
				</el-form-item>
				<el-form-item :label="$t('supplierList.confirmPassword')" prop="password2">
					<el-input v-model="form.password2" :maxlength="16" :minlength="6" show-password :placeholder="$t('supplierList.confirmPassword')" size="small" style="width: 85%;"></el-input>
				</el-form-item>

                <el-form-item :label="$t('supplierList.phone')" prop="phone">
					<el-input v-model="form.phone"  :placeholder="$t('supplierList.phone')" clearable size="small" style="width: 85%;" auto-complete="new-password"></el-input>
				</el-form-item>
                <el-form-item :label="$t('supplierList.email')" prop="email">
					<el-input v-model="form.email" :placeholder="$t('supplierList.email')" clearable size="small" style="width: 85%;" auto-complete="new-password"></el-input>
				</el-form-item>
                <el-form-item :label="$t('supplierList.local')" prop="local">
					<el-input v-model="form.local" :placeholder="$t('supplierList.local')" clearable size="small" style="width: 85%;" auto-complete="new-password"></el-input>
				</el-form-item>

				
				
                
			</el-form>

			<div slot="footer" class="dialog-footer">
				<el-button @click="hide">{{$t('system.cancel')}}</el-button>
				<el-button type="primary" @click="submit" :loading="this.layout.loading">{{$t('system.confirm')}}</el-button>
			</div>
		</el-dialog>

        <el-dialog :close-on-click-modal="false" :width="layout.is_phone?'90%':'80%'" :append-to-body="true"  :visible.sync="dialogTitleVisible" :title="$t('supplierList.loginUrl')">
			<p>{{ fullTitle }}</p>
		</el-dialog>

	</div>
</template>

<script>
	import { commondecrypt } from '@/main';
	import common from '@/common/mixins/common.js';
	import buttonSearch from '@/components/common/button-search.vue';
	import { mapState } from 'vuex';
	export default {
		components: {
			buttonSearch
		},
		inject: ['layout', 'app'],
		mixins: [common],
		data() {
			return {
                dialogTitleVisible: false,
				fullTitle: '',
                
				createModel: false,
				editIndex: -1,
				//搜索數据
				from: {
					name: '',
					time:[],
				},
				auth_val: 'Supplier',

                prop: 'sort',
                sort: 'ascending',

				preUrl: "user/supplierList", //列表地址
				// delAllUrl: "user/delAdminAll", //批量删除地址
				delUrl: "user/delSupplier", //删除單条地址
				addUrl: "user/addSupplier", //添加/修改地址
				editStatusUrl:"user/editStatusSupplier",//修改狀態地址

				tableData: [],
				form: {
                    name: "",
                    local: "",
                    email: '',
                    phone: '',
					sort: 1,
				},
				rules: {
					name: [{
						required: true,
						message: this.$t('supplierList.nameRequired'),
						trigger: 'blur',
					}],
					username: [{
						required: true,
						message: this.$t('supplierList.usernameRequired'),
						trigger: 'blur',
					}, {
						min: 6,
						max: 16,
						message: this.$t('supplierList.usernameLength'),
						trigger: 'blur'
					}],
					
				},
				agent_list: [],
				check_img_list:[]
			}
		},
		watch: {
			refreshTrigger(newVal) {
				this.getList();    // 如果有其他需要刷新的方法
				this.layout.getPageNum();
			},
		},
		computed: {
			// 监听 Vuex state
			...mapState(['refreshTrigger']), // 监听 Vuex state
		},
		created() {
			
		},
		methods: {
             // 顯示完整標題内容
			showFullTitle(title) {
				this.fullTitle = title;
				this.dialogTitleVisible = true;
			},
            validateParent(rule, value, callback) {
                if (this.form.id > 0) {
                    if (!value) {
                        return callback(new Error(this.$t('supplierList.passwordLength'))); // 只有 type == 2 时才校验
                    }
                }
                callback(); // 其他情况不校验
            },
			//提交
			async submit() {
				this.$refs.form.validate(res => {
					if (this.form.password != this.form.password2) {
						this.$message({
							message: this.$t('supplierList.passwordDifferent'),
							type: 'error'
						});
						return
					}
					if (res) {
						//this.form.default = this.form.default.replace(/\n/g,',')
						this.form.id = this.editIndex
						this.addOrEdit(this.form)
						// 關閉模态框
					}
				})
			},
			hide(){
                // 初始化表單
					this.form = {
						name: "",
                        local: "",
                        email: '',
                        phone: '',
                        sort: 1,
					}
					this.editIndex = -1
                    this.createModel = false
            },
			// 打开模态框
			openModel(e = false) {
				console.log(e)
				// 增加
				if (!e) {
					// 初始化表單
					this.form = {
						name: "",
						headUrl: "",
						icon: "",
						username: '',
						password: '',
						password2: '',
                        local: "",
                        email: '',
                        phone: '',
                        sort: 1,
					}
					this.editIndex = -1
				} else {
					// 修改
					this.form = {
						name: e.row.name,
						local: e.row.local,
						email: e.row.email,
						phone: e.row.phone,
						username: e.row.username,
						password: '',
						password2: '',
						headUrl: e.row.head,
						icon:e.row.head,
						sort:  e.row.sort
					}
					this.editIndex = e.row.id
				}
				// 打开dialog
				this.createModel = true
			},
			
			getListResult(e) {
				this.tableData = e.list
				this.check_img_list = e.list.map(item=>{
					return item.head
				})
			},
			handleAvatarSuccess(res, file) {
				this.form.icon = URL.createObjectURL(file.raw);
				let en_data = commondecrypt(res.encryption)
				res.encryption = JSON.parse(en_data)
				if(res.encryption.code==1){
					this.form.headUrl = res.encryption.data.list.url
				}
			  },
			beforeAvatarUpload(file) {
			
			    const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'  || file.type === 'image/gif';
			    const isLt2M = file.size / 1024 / 1024 < 12;
			
			    if (!isJPG) {
			    this.$message.error(this.$t('message.info_err'));
			    }
			    if (!isLt2M) {
			    this.$message.error(this.$t('message.img_max_err'));
			    }
			    return isJPG && isLt2M;
			
			   },
			// 清空篩選條件
			clearSearch() {
				this.from = {
					name: '',
					time:[],
				}
			
				this.search = ''
				this.getList()
			},
			// 選擇图片
			chooseImage() {
				this.app.chooseImage((res) => {
					//console.log(res)
					//this.form.headUrl = ''
					this.$set(this.form, 'headUrl', res[0].url);
					this.form['headId'] = res[0].id
					this.$set(this.form, 'headId', res[0].id);
					//this.form.headUrl = res[0].url
				}, 1)
			}
		}
	}
</script>

<style>
.custom-dialog {
  z-index: 3000!important; /* 设置更高的 z-index */
}
</style>
